import { useFeedState, useVideoHistory } from '~/composables/shorts';
import { usePropertyViewTracking } from '~/composables/usePropertyViewTracking';

export default defineNuxtPlugin(() => {
	const { ft_shorts_access_points } = useFeatureFlags();

	if (!ft_shorts_access_points) return;

	const { loggedIn } = useUserSession();
	const { syncOfflineViews, getOfflineViewsCount } = usePropertyViewTracking();
	const feedState = useFeedState();
	const { resetHistory } = useVideoHistory();

	function resetShortsClientCaches(): void {
		resetHistory();
		feedState.reset();
	}

	watch(loggedIn, async (isLoggedIn, wasLoggedIn) => {
		if (isLoggedIn && !wasLoggedIn) {
			const offlineCount = getOfflineViewsCount();
			if (offlineCount > 0) {
				try {
					await syncOfflineViews();
				} finally {
					resetShortsClientCaches();
				}
			}
		}
	});
});
